import {Button} from "@mui/material";
import SaveDialog from "./SaveDialog";
import {useBoolState} from "../../../../../hooks";
import {defineMessage, FormattedMessage} from "react-intl";
import {useDataSource} from "./DataSource";

type Props = {
    extensionId: number;
    domainId: number;
    onSuccess: () => void;
    disabled: boolean;
};

export default ({extensionId, domainId, onSuccess, disabled}: Props) => {
    const [isOpen, open, close] = useBoolState();
    const dataSource = useDataSource(domainId, isOpen, {userId: extensionId});

    return (
        <>
            <Button
                disabled={disabled}
                color="primary"
                size="small"
                onClick={open}
                variant="contained"
                id="create-provisioned-device"
            >
                <FormattedMessage id="devices.provisioned.create" defaultMessage="Create provisioned device" />
            </Button>
            <SaveDialog
                isOpen={isOpen}
                close={close}
                title={defineMessage({id: "devices.provisioned.create", defaultMessage: "Create provisioned device"})}
                dataSource={dataSource}
                onSuccess={onSuccess}
                cacheKeyPostfix="create"
            />
        </>
    );
};
